import { AliasModel } from "src/app/shared/models/alias.model";

export const AttachmentsBodyRegions: Array<{ id: number, name: string }> = [
  { id: 1, name: 'Upper Abdomen' },
  { id: 2, name: 'Lower Abdomen' },
  { id: 3, name: 'Head' },
  { id: 4, name: 'Neck' },
  { id: 5, name: 'Back' },
  { id: 6, name: 'Upper Limb (Right)' },
  { id: 7, name: 'Upper Limb (Left)' },
  { id: 8, name: 'Lower Limb (Right)' },
  { id: 9, name: 'Lower Limb (Left)' },
  { id: 10, name: 'Chest' },
  { id: 11, name: 'Abdomen' },
  { id: 12, name: 'Scalp' },
  { id: 13, name: 'Skull' },
  { id: 14, name: 'Brain' },
  { id: 15, name: 'Facial Bones' },
  { id: 16, name: 'Parotid Left/Right' },
  { id: 17, name: 'Sinuses' },
  { id: 18, name: 'Spine- Cervical' },
  { id: 19, name: 'Spine- Thoracic' },
  { id: 20, name: 'Spine- Lumbar' },
  { id: 21, name: 'Spine- All' },
  { id: 22, name: 'Thyroid' },
  { id: 23, name: 'Carotids' },
  { id: 24, name: 'Shoulder Left' },
  { id: 25, name: 'Shoulder Right' },
  { id: 26, name: 'Clavicle Left' },
  { id: 27, name: 'Clavicle Right' },
  { id: 28, name: 'Scapula Left' },
  { id: 29, name: 'Scapula Right' },
  { id: 30, name: 'Upper Arm Left' },
  { id: 31, name: 'Upper Arm Right' },
  { id: 32, name: 'Elbow Left' },
  { id: 33, name: 'Elbow Right' },
  { id: 34, name: 'Forearm Left' },
  { id: 35, name: 'Forearm Right' },
  { id: 36, name: 'Wrist Left' },
  { id: 37, name: 'Wrist Right' },
  { id: 38, name: 'Hand Left' },
  { id: 39, name: 'Hand Right' },
  { id: 40, name: 'Scaphoid Left' },
  { id: 41, name: 'Scaphoid Right' },
  { id: 42, name: 'Rib Views Left/Right' },
  { id: 43, name: 'Erect Chest' },
  { id: 44, name: 'Kub' },
  { id: 45, name: 'Pelvis' },
  { id: 46, name: 'Prostate' },
  { id: 47, name: 'Groin Left' },
  { id: 48, name: 'Groin Right' },
  { id: 49, name: 'Scrotum/Testicles' },
  { id: 50, name: 'Hip Left' },
  { id: 51, name: 'Hip Right' },
  { id: 52, name: 'Thigh Left' },
  { id: 53, name: 'Thigh Right' },
  { id: 54, name: 'Knee Left' },
  { id: 55, name: 'Knee Right' },
  { id: 56, name: 'Calf Left' },
  { id: 57, name: 'Calf Right' },
  { id: 58, name: 'Ankle Left' },
  { id: 59, name: 'Ankle Right' },
  { id: 60, name: 'Foot Left' },
  { id: 61, name: 'Foot Right' },
  { id: 62, name: 'Calcaneus Left' },
  { id: 63, name: 'Calcaneus Right' },
  { id: 64, name: 'Toe/s Left' },
  { id: 65, name: 'Toe/s Right' }
].sort((a, b) => a.name.localeCompare(b.name));

export const PersonTitles: string[] = ['Dr', 'Miss', 'Mr', 'Mrs', 'Prof', 'Sr', 'Mst', 'Ms'];

export const SpecialistTypes: AliasModel[] = [
  {
      "id": 25,
      "name": "Anesthesiologist",
      "alias": "anesthesiologist"
  },
  {
      "id": 24,
      "name": "Anesthetist",
      "alias": "anesthetist"
  },
  {
      "id": 42,
      "name": "Audiologist",
      "alias": "audiologist"
  },
  {
      "id": 26,
      "name": "Cardiologist",
      "alias": "cardiologist"
  },
  {
      "id": 28,
      "name": "Cardiothoracic Surgeon",
      "alias": "cardiothoracic_surgeon"
  },
  {
      "id": 3,
      "name": "Dental Surgeon",
      "alias": "dental_surgeon"
  },
  {
      "id": 29,
      "name": "Dermatologist",
      "alias": "dermatologist"
  },
  {
      "id": 4,
      "name": "Ear, Nose and Throat Specialist",
      "alias": "ear_nose_and_throat_specialist"
  },
  {
      "id": 5,
      "name": "Endocrinologist",
      "alias": "endocrinologist"
  },
  {
      "id": 22,
      "name": "General Surgeon",
      "alias": "general_surgeon"
  },
  {
      "id": 6,
      "name": "Gynaecologist",
      "alias": "gynaecologist"
  },
  {
      "id": 7,
      "name": "Maxillofacial Surgeon",
      "alias": "maxillofacial_surgeon"
  },
  {
      "id": 33,
      "name": "Neonatal Intensivist",
      "alias": "neonatal_intensivist"
  },
  {
      "id": 30,
      "name": "Nephologist",
      "alias": "nephologist"
  },
  {
      "id": 32,
      "name": "Neurologist",
      "alias": "neurologist"
  },
  {
      "id": 27,
      "name": "Neurosurgeon",
      "alias": "neurosurgeon"
  },
  {
      "id": 8,
      "name": "Oncologist",
      "alias": "oncologist"
  },
  {
      "id": 9,
      "name": "Ophthalmologist",
      "alias": "ophthalmologist"
  },
  {
      "id": 10,
      "name": "Orthodontist",
      "alias": "orthodontist"
  },
  {
      "id": 11,
      "name": "Orthopaedic Surgeon",
      "alias": "orthopaedic_surgeon"
  },
  {
      "id": 35,
      "name": "Paediatric Cardiologist",
      "alias": "paediatric_cardiologist"
  },
  {
      "id": 37,
      "name": "Paediatric Cardiothoracic Surgeon",
      "alias": "paediatric_cardiothoracic_surgeon"
  },
  {
      "id": 38,
      "name": "Paediatric Dermatologist",
      "alias": "paediatric_dermatologist"
  },
  {
      "id": 34,
      "name": "Paediatric Intensivist",
      "alias": "pediatric_intensivist"
  },
  {
      "id": 39,
      "name": "Paediatric Nephrologist",
      "alias": "paediatric_nephrologist"
  },
  {
      "id": 41,
      "name": "Paediatric Neurologist",
      "alias": "paediatric_neurologist"
  },
  {
      "id": 36,
      "name": "Paediatric Neurosurgeon",
      "alias": "paediatric_neurosurgeon"
  },
  {
      "id": 40,
      "name": "Paediatric Pulmonologist",
      "alias": "paediatric_pulmonologist"
  },
  {
      "id": 23,
      "name": "Paediatric Surgeon",
      "alias": "pediatric_surgeon"
  },
  {
      "id": 20,
      "name": "Paediatrician",
      "alias": "paediatrician"
  },
  {
      "id": 13,
      "name": "Podiatrist",
      "alias": "podiatrist"
  },
  {
      "id": 14,
      "name": "Prosthodontist",
      "alias": "prosthodontist"
  },
  {
      "id": 21,
      "name": "Psychiatrist",
      "alias": "psychiatrist"
  },
  {
      "id": 31,
      "name": "Pulmonologist",
      "alias": "pulmonologist"
  },
  {
      "id": 19,
      "name": "Radiation Oncologist",
      "alias": "radiation_oncologist"
  },
  {
      "id": 17,
      "name": "Radiologist",
      "alias": "radiologist"
  },
  {
      "id": 18,
      "name": "Rheumatologist",
      "alias": "rheumatologist"
  },
  {
      "id": 1,
      "name": "Specialist Surgeon",
      "alias": "specialist_surgeon"
  },
  {
      "id": 16,
      "name": "Thoracic Surgeon",
      "alias": "thoracic_surgeon"
  },
  {
      "id": 15,
      "name": "Urologist",
      "alias": "urologist"
  }
].sort((a, b) => a.name.localeCompare(b.name));
